import TemplateConfig from "@/views/configs/template/index.vue";
import TemplatePrescriptionConfig from "@/views/configs/template/prescription/index.vue";
import TemplateClinicTerapyConfig from "@/views/configs/template/clinic_therapy/index.vue";
import TemplateSurgeryTerapyConfig from "@/views/configs/template/surgery_therapy/index.vue";

export default [
  {
    path: "protocolos",
    name: "Config Protocolos",
    component: TemplateConfig,
    redirect: {
      path: "/configuracoes/protocolos/receituario",
    },
    children: [
      {
        path: "receituario",
        name: "Config preotocolo receituário",
        component: TemplatePrescriptionConfig,
      },
      {
        path: "terapeutica-clinica",
        name: "Config terapêutica clinica",
        component: TemplateClinicTerapyConfig,
      },
      {
        path: "terapeutica-cirurgica",
        name: "Config terapêutica cirúrgica",
        component: TemplateSurgeryTerapyConfig,
      },
    ],
  },
];
